<ng-template #contentTemplate>
  <div class="mui-hero-content">
    <ng-content></ng-content>
    <ng-content select="mui-hero-page-title"></ng-content>
  </div>
</ng-template>
<ng-template #toolbarTemplate>
  <ng-content select="[mui-hero-toolbar-buttons]"></ng-content>
</ng-template>
<ng-template #fullscreenHeaderTemplate>
  <ng-content select="[mui-hero-fullscreen-header]"></ng-content>
</ng-template>
